// components/featuredProviders/RecentlyJoinedSection.jsx
import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import "../featuredAcademiesSection/FeaturedAcademiesSection.css";
import { fetchProviders, ProviderGrid } from "./FeaturedProvidersSection";

// Newest sign-ups whose profiles already meet the minimum completion/quality
// bar (enforced backend-side for sort=recent — see getTutorsAndAcademies).
// Placed lower on the homepage, below Verified Providers/Testimonials, since
// these providers haven't yet built up the track record verified ones have.
const RecentlyJoinedSection = () => {
  const { data: recentTutors = [], isLoading: loadingRecentTutors } = useQuery({
    queryKey: ["featured-providers", "recent", "tutor"],
    queryFn: () => fetchProviders("tutor", "&sort=recent"),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const { data: recentAcademies = [], isLoading: loadingRecentAcademies } =
    useQuery({
      queryKey: ["featured-providers", "recent", "institution"],
      queryFn: () => fetchProviders("institution", "&sort=recent"),
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    });

  const loadingRecent = loadingRecentTutors || loadingRecentAcademies;

  const recentProviders = useMemo(() => {
    const combined = [...recentTutors, ...recentAcademies];
    return [...combined]
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
      .slice(0, 8);
  }, [recentTutors, recentAcademies]);

  return (
    <section className="featured-section academies">
      <div className="featured-container">
        <ProviderGrid
          title="Recently Joined"
          subtitle="Newest tutors and training centers on TUTORSLINKS"
          providers={recentProviders}
          loading={loadingRecent}
          showJoinedDate
          emptyMessage="No new providers to show yet."
        />
      </div>
    </section>
  );
};

export default RecentlyJoinedSection;
